import React from 'react'

import { GroupCard } from './GroupCard.component'
import { IGroupCardInfo } from 'interfaces'

// styles
import { groupsContainer } from 'styles/v2/pages/profile'

interface Props {
  groups: IGroupCardInfo[]
}
export const GroupsContainer: React.FC<Props> = ({ groups }) => {
  return (
    <div className={groupsContainer}>
      {groups.map((group, index) => (
        <GroupCard key={index} {...group} />
      ))}
    </div>
  )
}
